var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',_vm._g({attrs:{"id":"themed-icon","left":_vm.left,"small":_vm.small,"color":_vm.color}},_vm.vOn),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }